export class SurgicalHistoryModel {
patientcode = '' ;
operationsname = '' ;
date = '2022-01-01' ;
surgicaldoctor = '' ;
tsize = '' ;
nodalstatus = '' ;
ps = '' ;
compcode = '' ;
userid = '' ;
modifieddate  ='2022-01-01'

}
export class SurgTypeModel {
  surtypecode = '' ;
  surtypename = '' ;
  surtypenotes = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate  ='2022-01-01'

  }

